import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

export type Apontamento = {
  talhaoId: string;
  talhaoIdExterno: string;
  possuiApontamento: boolean;
};

export function useGetApontamentoTalhoes(ordemServicoId: string, talhaoIds: string[]) {
  return useQuery(
    [URL.ORDEM_SERVICO.OBTER_APONTAMENTO(ordemServicoId, talhaoIds)],
    async () => {
      const { data } = await http.get<Apontamento[]>(URL.ORDEM_SERVICO.OBTER_APONTAMENTO(ordemServicoId, talhaoIds));
      return data;
    },
    {
      enabled: !!ordemServicoId && !!talhaoIds,
    }
  );
}
